import { AxiosResponse } from "axios";
import { SET_FULLENRICH, SET_ERRORMSG } from "@/store/mutation-types";
import { CLEAR_FULLENRICH_ISLOADING, REQUEST_ENRICHMENT } from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import Fullenrich from "@/services/fullenrich";
import { Module } from "vuex";
import { RequestEnrichment } from "@/dtos/Fullenrich.dto";

const fullenrich: Module<any, {}> = {
  state: {
    fullenrich: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    fullenrich: (state: { fullenrich: any }) => state.fullenrich,
  },
  mutations: {
    [SET_FULLENRICH]: (
      state: { fullenrich: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.fullenrich.data = payload.data;
      state.fullenrich.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REQUEST_ENRICHMENT]: async ({ commit }: any, payload: any) => {
      commit(SET_FULLENRICH, { data: null, isLoading: true });

      const result: AxiosResponse = await Fullenrich.requestEnrichment(
        payload as RequestEnrichment
      );

      if (result) {
        if (result.data.status) {
          commit(SET_FULLENRICH, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_FULLENRICH, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FULLENRICH, { isLoading: false });
        return false;
      }
    },
    [CLEAR_FULLENRICH_ISLOADING]: ({ commit }) => {
      commit(SET_FULLENRICH, { isLoading: false });
    },
  },
};

export default fullenrich;
